

import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';


import React, { Fragment, useContext, useEffect } from 'react';
import HomePsico from '../views/psicologo/home_psico';
import CitaSinglePsico from '../views/psicologo/cita_single_psico';
import HomeClient from '../views/client/home_client';
import CreateAppointment from '../views/client/agendar_view';
import LoginView from '../views/commun/login_view';
import { AuthContext } from '../context/auth_context';
import DashboardClient from '../views/client/dashboard_client';
import FamiliaClient from '../views/client/familia_client';
import PerfilClient from '../views/client/perfil_client';
import TipsClient from '../views/client/tips_client';
import DocumentosClient from '../views/client/documentos_client';
import PreciosClient from '../views/client/precios_cliente';
import PlanActualClient from '../views/client/plan_actual_client';
import CardCheckOutClient from '../views/client/card_checkout_client';



function ClientNavigator() {
  return (

    <PrivateRoute>
      <Routes>
        <Route path="/" element={<HomeClient></HomeClient>} />
        <Route path="/crear-cita" element={<CreateAppointment></CreateAppointment>} />
        <Route path="/citas" element={<DashboardClient></DashboardClient>} />
        <Route path="/family" element={<FamiliaClient></FamiliaClient>} />
        <Route path="/profile" element={<PerfilClient></PerfilClient>} />
        <Route path="/tips" element={<TipsClient></TipsClient>} />
        <Route path="/documentos" element={<DocumentosClient></DocumentosClient>} />
        <Route path="/precios" element={<PreciosClient></PreciosClient>} />
        <Route path="/plan-actual" element={<PlanActualClient></PlanActualClient>} />
        <Route path="/success" element={<PreciosClient></PreciosClient>} />
      </Routes>
    </PrivateRoute>

  );
}



function PrivateRoute({ children }) {

  const { user, auth, loading } = useContext(AuthContext);


  let token = localStorage.getItem('token');
  if (token !== null) {

    if (loading) {
      return <></>
      
    }

    if (user.roles?.includes('User') && !loading) {

      return children;
    }

  } else {
    return <Navigate to="/" />
  }



  // return user.roles?.includes('User') && !loading ? children : <Navigate to="/" />;
}


export default ClientNavigator;
